import { Component } from '@angular/core';
import { ProjectItemWithSelectionComponent } from "./project-item-withselection.component";

@Component({
    selector: 'production-office',
    standalone: false,
    templateUrl: 'production-office.component.html',
    styleUrls: ['./production-office.component.css']
})
export class ProductionOfficeComponent extends ProjectItemWithSelectionComponent {

}
